import { UIView, useCurrentStateAndParams } from "@uirouter/react";

import { SwDemoBanner } from "app/components/sw-demo-banner/SwDemoBanner";

export const DemandAnalysisRoot = () => {
    const { state } = useCurrentStateAndParams();
    return (
        <div className="sw-layout-no-scroll-container">
            <div
                className={`sw-page-${state.name?.replace(".", "-")}`}
                style={{ height: "100%", overflow: "auto" }}
            >
                <SwDemoBanner type="basic" />
                <UIView />
            </div>
        </div>
    );
};
